import { useMutation, useQueryClient } from '@tanstack/react-query';

import { exercisesService } from '../services';

import { exercisesKeys } from './useExercises';

export function useArchiveExercise(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => exercisesService.archive(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: exercisesKeys.lists() });
      void qc.invalidateQueries({ queryKey: exercisesKeys.detail(id) });
    },
  });
}
